<template>
  <!-- start of form -->
  <div class="container shape-container d-flex align-items-center">
    <loading :active.sync="isLoading" loader="spinner" color="#20A8D8" :is-full-page="false" />
    <div class="col">
      <div class="row justify-content-center align-items-center">
        <div class="col-lg-12">
          <form @submit.prevent="submit() && reset">
            <fieldset class="border border-primary rounded p-5 contact-form">
              <legend class="text-center display-3 px-3">GET IN TOUCH</legend>
              <div class="text-center primary-header">
                <h4 class="display-4">PRIMARY DETAILS</h4>
              </div>
              <div class="row">
                <!-- 1st column 1st row  -->
                <div class="col-lg-6">
                  <!-- firstname -->
                  <div class="form-group">
                    <label class="form-label" for="firstname">
                      First Name
                      <span class="badge badge-danger bg-transparent pl-0">
                        *
                      </span>
                    </label>
                    <input v-model="form.firstname" @input="validatefirstName" class="form-control border border-dark"
                      type="text" name="firstname" placeholder="ex. Juan" id="firstname" required />
                  </div>
                  <!-- lastname -->
                  <div class="form-group">
                    <label class="form-label" for="lastname">
                      Last Name
                      <span class="badge badge-danger bg-transparent pl-0">
                        *
                      </span>
                    </label>
                    <input v-model="form.lastname" @input="validatelastName" class="form-control border-dark" type="text"
                      name="lastname" placeholder="ex. De La Cruz" id="lastname" required />
                  </div>
                  <!-- phonenumber -->
                  <div class="form-group">
                    <label class="form-label" for="phoneNumber">
                      Phone Number
                      <span class="badge badge-danger bg-transparent pl-0">
                        *
                      </span>
                    </label>
                    <input v-model="form.phoneNumber" @input="validatephoneNumber" class="form-control border-dark"
                      type="text" name="phoneNumber" minlength="15" placeholder="(0912)-345-6789" id="phoneNumber"
                      required />
                  </div>
                  <!-- profession/role -->
                  <div class="form-group">
                    <label class="form-label" for="role">
                      Profession/Role
                    </label>
                    <input v-model="form.role" @input="validateRole" class="form-control border border-dark" name="role"
                      placeholder="Profession/Role" id="role" />
                  </div>
                </div>
                <!-- 2nd column 1st row -->
                <div class="col-lg-6">
                  <!-- email -->
                  <div class="form-group">
                    <label class="form-label" for="email">
                      Email
                      <span class="badge badge-danger bg-transparent pl-0">
                        *
                      </span>
                    </label>
                    <input v-model="form.email" class="form-control border border-dark" type="email" name="email"
                      placeholder="ex. example@test.com" id="email" required />
                  </div>
                  <!-- company -->
                  <div class="form-group">
                    <label class="form-label" for="companyName">
                      Company
                      <span class="badge badge-danger bg-transparent pl-0">
                        *
                      </span>
                    </label>
                    <input v-model="form.company" class="form-control border border-dark" type="text" name="companyName"
                      placeholder="Company Name" id="companyName" required />
                  </div>
                  <!-- company address -->
                  <div class="form-group">
                    <label class="form-label" for="companyAddress">
                      Company Address
                      <span class="badge badge-danger bg-transparent pl-0">
                        *
                      </span>
                    </label>
                    <input v-model="form.companyAddress" class="form-control border-dark" type="text"
                      name="companyAddress" placeholder=" Company Address" id="companyAddress" required />
                  </div>
                  <!-- aboutus -->
                  <div class="form-group">
                    <label class="form-label" for="aboutUs">
                      How did you hear about us?
                      <span class="badge badge-danger bg-transparent pl-0">
                        *
                      </span>
                    </label>
                    <select v-model="form.selection" class="form-control border-dark" name="aboutUs" id="aboutUs"
                      required>
                      <option value="" disabled>-please select-</option>
                      <option v-for="item in hearAboutOptions" :value="item" :key="item">
                        {{ item }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-lg-12">
                  <!-- Message -->
                  <div class="form-group">
                    <label class="form-label" for="message">
                      Message
                      <span class="badge badge-danger bg-transparent pl-0">
                        *
                      </span>
                    </label>
                    <textarea v-model="form.message" class="form-control border border-dark" type="text" name="message"
                      placeholder="Type a message..." id="message" rows="3" required></textarea>
                  </div>
                </div>
              </div>

              <!-- with inquiries checkbox -->
              <div class="form-check">
                <input v-model="form.withInquiries" class="form-check-input custom-checkbox"
                  style="width: 15px; height: 15px;" type="checkbox" id="withInquiries" />
                <label class="form-check-label" style="font-size: large;" for="withInquiries">
                  Request for a Quote?
                </label>
              </div>

              <div v-if="form.withInquiries" class="inquiriesContainer">
                <div class="text-center primary-header">
                  <h4 class="display-4 mt-4 mb-4">PROJECT INFORMATION</h4>
                </div>

                <div class="row">
                  <!-- Project Details  -->
                  <div class="col-lg-6">
                    <div class="secondary-header">
                      <h4 class="display-4 mt-2">PROJECT DETAILS</h4>
                    </div>
                    <!-- projectName -->
                    <div class="form-group">
                      <label class="form-label" for="projectName">
                        Project Name
                        <span class="badge badge-danger bg-transparent pl-0">
                          *
                        </span>
                      </label>
                      <input v-model="form.projectName" class="form-control border border-dark" type="text"
                        name="projectName" placeholder="ex. FPIP Warehouse A Perimeter Fencing" id="projectName"
                        :required="form.withInquiries" />
                    </div>
                    <!-- Project Type -->
                    <div class="form-group">
                      <label class="form-label" for="projectType">
                        Project Type
                        <span class="badge badge-danger bg-transparent pl-0">
                          *
                        </span>
                      </label>
                      <select v-model="form.selectionType" class="form-control border-dark" name="projectType"
                        id="projectType" :required="form.withInquiries">
                        <option value="" disabled>-please select-</option>
                        <option v-for="item in projectTypeOptions" :value="item" :key="item">
                          {{ item }}
                        </option>
                      </select>
                    </div>
                    <!-- Project Location -->
                    <div class="form-group">
                      <label class="form-label" for="projectLocation">
                        Project Location
                        <span class="badge badge-danger bg-transparent pl-0">
                          *
                        </span>
                      </label>
                      <input v-model="form.projectLocation" class="form-control border-dark" type="text"
                        name="projectLocation" placeholder="Street, Barangay, City, Province, Zip Code"
                        id="projectLocation" :required="form.withInquiries" />
                    </div>
                  </div>

                  <!-- 2nd column 1st row -->
                  <div class="col-lg-6">
                    <div class="secondary-header">
                      <h4 class="display-4 mt-sm-4 mt-md-4 mt-lg-0">
                        PROJECT SPECIFICATION
                      </h4>
                    </div>
                    <!-- totalHeight -->
                    <div class="form-group">
                      <label class="form-label" for="totalHeight">
                        Total Height(m)
                        <span class="badge badge-danger bg-transparent pl-0">
                          *
                        </span>
                      </label>
                      <select v-model="form.selectionHeight" class="form-control border-dark" name="totalHeight"
                        id="totalHeight" :required="form.withInquiries">
                        <option value="" disabled>-please select-</option>
                        <option v-for="item in totalHeightOptions" :value="item" :key="item">
                          {{ item }}
                        </option>
                      </select>
                    </div>
                    <!-- Total Length -->
                    <div class="form-group">
                      <label class="form-label" for="totalLength">
                        Total Length(m)
                        <span class="badge badge-danger bg-transparent pl-0">
                          *
                        </span>
                      </label>
                      <input @input="validateLength" v-model="form.totalLength" class="form-control border-dark"
                        type="text" name="totalLength" placeholder="Enter length in meters" id="totalLength"
                        :required="form.withInquiries" />
                    </div>
                    <!-- with barbed wire -->
                    <div class="form-group">
                      <label class="form-label" for="support">
                        With Barbed wire? (Select support and layer no.s)
                        <span class="badge badge-danger bg-transparent pl-0">
                          *
                        </span>
                      </label>
                      <select v-model="form.selectionWire" class="form-control border-dark" name="support" id="support"
                        :required="form.withInquiries">
                        <option value="" disabled>-please select-</option>
                        <option v-for="item in barbedWireOptions" :value="item" :key="item">
                          {{ item }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <!-- Image area -->
                  <div class="col-lg-6 col-sm-12">
                    <div class="render">
                      <div class="secondary-header">
                        <h4 class="display-4 mt-4 ml-4">DESIGN DRAWING</h4>
                      </div>
                      <img class="text-center" style="width: 100%; height: 70%;" v-if="form.renderImage"
                        :src="form.renderImage" alt="3D Render" />
                      <div class="d-flex ml-4" v-else>
                        No image available
                      </div>
                    </div>
                  </div>
                  <!-- Site Development Plan -->
                  <div class="col-lg-6 col-sm-12">
                    <div class="secondary-header">
                      <h4 class="display-4 mt-4">SITE DEVELOPMENT PLAN</h4>
                      <div class="file-upload-container">
                        <div class="file-upload-input">
                          <input id="fileUpload" type="file" ref="fileInput" class="file-input" @change="handleFileUpload"
                            accept=".pdf" />
                          <label for="fileUpload" class="file-label d-flex align-items-center bg-transparent">
                            <i class="fa fa-folder-o mr-3 text-primary" style="font-size: 3rem;"></i>
                            <span v-if="!fileUpload">Upload Here</span>
                            <span v-else>{{ fileUpload.name }}</span>
                            <span class="badge badge-danger bg-transparent pl-0" v-show="!fileUpload">
                              *
                            </span>
                          </label>
                          <p class="badge badge-danger bg-transparent ml-3" v-if="fileSizeExceeded">
                            File size exceeded the limit of
                            {{ maxFileSize / 1000000 }} MB
                          </p>
                        </div>
                      </div>
                      <div v-if="fileUploadError" class="error-message">
                        Only PDF files are allowed.
                      </div>

                      <p class="paraBot font-italic text-left">
                        For more accurate costing and composite design
                        requirements, kindly contact any of our sales personnel
                        for detailed costing
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="text-center">
                <button type="submit" class="btn-submit btn-primary border border-primary" :class="{
                  'btn-submit': form.withInquiries,
                  bottom: form.withInquiries,
                }">
                  SUBMIT
                </button>
              </div>
            </fieldset>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// DAO
import { storage } from "../config/firebase";
import contactFormDAO from "../database/contactForms";

import config from "@/config/constants";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "contact-us",
  components: {
    Loading,
  },
  data() {
    return {
      form: {
        // basic
        id: "",
        firstname: "",
        lastname: "",
        phoneNumber: "",
        email: "",
        role: "",
        company: "",
        companyAddress: "",
        selection: "",
        message: "",
        // with quote request
        projectName: "",
        selectionType: "",
        projectLocation: "",
        selectionHeight: "",
        totalLength: "",
        selectionWire: "",
        renderImage: null,
        cost: 0,
        isOnGoing: true,
        withInquiries: true,
        // timestamp
        dateCreated: Date.now(),
        dateUpdated: Date.now(),
      },

      hearAboutOptions: ["FACEBOOK", "LINKEDIN", "REFERRALS"],
      projectTypeOptions: ["Residential", "Commercial", "Industrial"],
      totalHeightOptions: [
        "1.75 meters ≅ (5'9\")",
        "2.1 meters ≅ (6'10\")",
        "2.45 meters ≅ (8')",
        "2.8 meters ≅ (9'2\")",
      ],
      barbedWireOptions: [
        "Angle Bar , 4 Strands",
        "Angle Bar , 5 Strands",
        "GI Pipe , 4 Strands",
        "GI Pipe , 5 Strands",
        "None",
      ],

      fileUpload: null,
      fileUploadError: "",

      // limit MB upload
      maxFileSize: 2000000,
      fileSizeExceeded: false,

      // Loading indicator
      isLoading: false,
    };
  },
  watch: {
    "form.selectionHeight"() {
      this.updateForm();
    },
    "form.selectionWire"() {
      this.updateForm();
    },
  },

  methods: {
    async updateForm() {
      const heightMapping = {
        "1.75 meters ≅ (5'9\")": {
          "Angle Bar , 4 Strands": "Iteration1.PNG",
          "Angle Bar , 5 Strands": "Iteration2.PNG",
          "GI Pipe , 4 Strands": "Iteration3.jpg",
          "GI Pipe , 5 Strands": "Iteration4.jpg",
          None: "Iteration5.jpg",
        },
        "2.1 meters ≅ (6'10\")": {
          "Angle Bar , 4 Strands": "Iteration6.PNG",
          "Angle Bar , 5 Strands": "Iteration7.PNG",
          "GI Pipe , 4 Strands": "Iteration8.jpg",
          "GI Pipe , 5 Strands": "Iteration9.jpg",
          None: "Iteration10.jpg",
        },
        "2.45 meters ≅ (8')": {
          "Angle Bar , 4 Strands": "Iteration11.PNG",
          "Angle Bar , 5 Strands": "Iteration12.PNG",
          "GI Pipe , 4 Strands": "Iteration13.jpg",
          "GI Pipe , 5 Strands": "Iteration14.jpg",
          None: "Iteration15.jpg",
        },
        "2.8 meters ≅ (9'2\")": {
          "Angle Bar , 4 Strands": "Iteration16.PNG",
          "Angle Bar , 5 Strands": "Iteration17.PNG",
          "GI Pipe , 4 Strands": "Iteration18.jpg",
          "GI Pipe , 5 Strands": "Iteration19.jpg",
          None: "Iteration20.jpg",
        },
      };

      const selectedHeight = this.form.selectionHeight;
      const selectedWire = this.form.selectionWire;

      try {
        // Get a reference to the image file
        const imageFilename = heightMapping[selectedHeight][selectedWire];
        if (imageFilename) {
          const imageRef = storage
            .ref()
            .child(`images/iterations/${imageFilename}`);

          // Get the download URL of the image
          const imageURL = await imageRef.getDownloadURL();

          // Store the URL in the data property
          this.form.renderImage = imageURL;
        }
      } catch (error) {
        console.error(error);
      }
    },

    computeCost() {
      const selectedHeight = this.form.selectionHeight;
      const selectedWire = this.form.selectionWire;
      const iterationKey = config.ITERATION_MAP[selectedHeight][selectedWire];
      const iterationCol = config.ITERATIONS[iterationKey];

      let totalCost = 0.0;

      if (iterationCol && iterationCol.length > 0) {
        const length = parseInt(this.form.totalLength);

        for (let i = 0; i < iterationCol.length - 1; i++) {
          const currentIteration = iterationCol[i];
          const nextIteration = iterationCol[i + 1];

          if (
            length >= currentIteration.len &&
            length <= nextIteration.len - 1
          ) {
            totalCost = length * currentIteration.price;
            break;
          }
        }

        const lastIteration = iterationCol[iterationCol.length - 1];
        const firstIteration = iterationCol[0];
        if (length >= lastIteration.len) {
          totalCost = length * lastIteration.price;
        } else if (length <= firstIteration.len) {
          totalCost = length * firstIteration.price;
        }
      }

      return totalCost
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    // Function to format number with commas as thousands separators
    formatNumber(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file.type === "application/pdf") {
        this.fileUpload = file;
        this.fileUploadError = "";
      } else {
        this.fileUpload = null;
        this.fileUploadError = "Only PDF files are allowed.";
      }
      if (file.size > this.maxFileSize) {
        this.fileSizeExceeded = true;
        return;
      }
      const reader = new FileReader();
      reader.onloadend = () => {
        this.fileSizeExceeded = false;
      };
      reader.readAsArrayBuffer(file);
    },

    generateCustomID() {
      const prefix = "EHI";
      const randomNumber = Math.floor(Math.random() * 1000);
      const date = new Date();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const year = String(date.getFullYear());

      return `${prefix}${randomNumber}-${month}${day}${year}`;
    },

    async submit() {
      try {
        // show loading indicator
        this.isLoading = true;

        let contactForm = Object.assign({}, this.form);
        contactForm.requestId = this.generateCustomID();

        if (this.form.withInquiries) {

          if (this.fileSizeExceeded) {
            this.$toast.error(
                "File size exceeded the limit of 2 MB",
                "Submission failed"
              );
              this.isLoading = false;
              return;
          }

          // compute cost
          contactForm.cost = this.computeCost();

          if (this.fileUpload) {
            const fileRef = storage
              .ref()
              .child(`files/${this.createFilePDFName()}`);
            await fileRef.put(this.fileUpload);

            // assign uploaded url
            const fileURL = await fileRef.getDownloadURL();
            contactForm.fileURL = fileURL;
          } else {
            this.$toast.error(
              "Please upload a site development plan to proceed",
              "Submission failed"
            );
            this.isLoading = false;
            return;
          }
        }

        await contactFormDAO.create(contactForm);
        this.reset();

        this.$toast.success(
          "Please wait for further notice from one of our customer support representative. ",
          "Contact request was successfully sent!"
        );
      } catch (error) {
        this.$toast.error(
          "Please try again later.",
          "Contact request failed to submit"
        );
        console.log(error);
      }

      // hide loading indicator
      this.isLoading = false;
    },

    // Validations
    validatefirstName(event) {
      const cleanedValue = event.target.value.replace(/[^A-Za-z-ñ\s]/g, "");
      this.form.firstname = cleanedValue;
    },
    validatelastName(event) {
      const cleanedValue = event.target.value.replace(/[^A-Za-z-ñ\s]/g, "");
      this.form.lastname = cleanedValue;
    },
    validateRole(event) {
      const cleanedValue = event.target.value.replace(/[^A-Za-z-ñ\s]/g, "");
      this.form.role = cleanedValue;
    },
    validatephoneNumber(event) {
      const cleanedValue = event.target.value.replace(/\D/g, "");
      this.form.phoneNumber = cleanedValue;

      if (cleanedValue.length <= 4) {
        this.form.phoneNumber = cleanedValue;
      } else if (cleanedValue.length <= 7) {
        this.form.phoneNumber = `(${cleanedValue.substr(
          0,
          4
        )}) ${cleanedValue.substr(4)}`;
      } else {
        this.form.phoneNumber = `(${cleanedValue.substr(
          0,
          4
        )}) ${cleanedValue.substr(4, 3)}-${cleanedValue.substr(7, 4)}`;
      }
      this.form.phoneNumber = this.form.phoneNumber.substr(0, 15);
    },
    validateLength(event) {
      const cleanedValue = event.target.value.replace(/[^0-9]/g, "");
      this.form.totalLength = cleanedValue;
    },

    createFilePDFName() {
      const prefix = "DOWNLOAD-FILE";
      const randomNumber = Math.floor(Math.random() * 1000);
      const date = new Date();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const year = String(date.getFullYear());

      return `${prefix}-${randomNumber}-${month}${day}${year}`;
    },

    reset() {
      this.form = {
        // basic
        id: "",
        firstname: "",
        lastname: "",
        phoneNumber: "",
        email: "",
        role: "",
        company: "",
        companyAddress: "",
        selection: "",
        message: "",
        // with quote request
        projectName: "",
        selectionType: "",
        projectLocation: "",
        selectionHeight: "",
        totalLength: "",
        selectionWire: "",
        renderImage: null,
        cost: 0,
        isOnGoing: true,
        withInquiries: false,
        // timestamp
        dateCreated: Date.now(),
        dateUpdated: Date.now(),
      };

      this.fileUpload = null;
      this.fileUploadError = "";

      // Scroll to the top of the page and reset the withInquiries form
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style scoped>
input,
select {
  color: black !important;
}

.container {
  position: relative;
  margin: 10% auto 5% auto !important;
}

.project-info {
  margin-top: 2%;
}

.secondary-header h4,
.primary-header h4 {
  color: #5e5e69;
  font-size: 1.4rem;
  font-weight: 700;
}

.btn-submit {
  position: absolute;
  bottom: -2.5%;
  left: 40%;
  width: 20%;
  padding: 5px;
  border-radius: 20px;
  color: #4e5152;
  font-weight: 600;
  cursor: pointer;
}

/* for withInquiries button submit */
.bottom {
  top: 98.75%;
  height: 2.25rem;
}

.btn-submit:hover {
  background-color: black;
  color: white;
}

.badge {
  font-size: 15px;
}

.contact-form {
  position: relative;
  padding: 2rem 7rem 2rem 7rem;
  margin-bottom: 120px;
}

.contact-form .paraBot {
  color: rgb(78, 81, 82);
  bottom: 10px;
  font-size: 0.7rem;
}

legend {
  color: #4e5152;
  width: fit-content;
}

#role,
#aboutUs {
  -webkit-appearance: none;
}

#role::-ms-expand,
#aboutUs::-ms-expand {
  display: none;
}

.render {
  border: 5px solid #eda711;
  border-radius: 30px;
  height: 50vh;
}

.file-upload-container {
  display: flex;
  align-items: center;
}

.file-upload-input {
  flex: 1;
}

.file-input {
  display: none;
}

.file-label {
  background-color: #e9e9e9;
  padding: 10px 20px;
  cursor: pointer;
  width: fit-content;
}

.error-message {
  color: red;
  font-size: 0.8rem;
  margin-bottom: 1rem;
  margin-top: -1rem;
}

/* Customize the checkbox appearance */
#withInquiries {
  accent-color: #eda711;
}

/* galaxy fold */
@media only screen and (max-width: 280px) {
  legend {
    font-size: 1rem !important;
  }

  .secondary-header h4,
  .project-info h4 {
    font-size: 0.9rem !important;
  }

  .btn-submit {
    left: 30% !important;
    width: 40% !important;
  }
}

@media only screen and (min-width: 600px) {
  .btn-submit {
    bottom: -1.2%;
  }
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .container {
    margin: 25% auto 10% auto !important;
  }

  legend {
    font-size: 1.5rem;
  }

  .secondary-header h4,
  .project-info h4 {
    font-size: 1rem;
  }

  .btn-submit {
    bottom: -1.8%;
    width: 25%;
  }

  .bottom {
    top: 99.25%;
    height: 2.25rem;
  }
}

/* Small devices (portrait tablets and large phones, 600px and up) */

@media only screen and (min-width: 768px) {
  .container {
    margin: 15% auto 15% auto;
  }

  .btn-submit {
    bottom: -1.5%;
  }

  .bottom {
    top: 99.3%;
    height: 2.25rem;
  }
}

@media only screen and (min-width: 992px) {
  .btn-submit {
    bottom: -2.75% !important;
  }

  .bottom {
    top: 98.7%;
    height: 2.25rem;
  }
}
</style>
